<template>
  <div class="header">
    <router-link 
      class = "logo"
      to    = "/" 
    >
      <img src="../../assets/Logo_Glimpse_128x128.png" />
      <div class="ml-3 text">GLIM</div>
    </router-link>

    <v-spacer></v-spacer>

    <div class="controls">
      <License></License>
      <ApplicationMenu></ApplicationMenu>
    </div>
  </div>
</template>

<script lang="js">

// #region Imports

/* Telestream */
import ApplicationMenu from './components/ApplicationMenu';
import License from '../app-user-info/License';

// #endregion Imports

export default {

  // #region Properties

  name:       'Header',
  components: {
    ApplicationMenu,
    License
  }

  // #endregion Properties

}
</script>

<style scoped lang="scss">
.header {
  display: flex;
  flex-direction: row;
  width: 100%;

  .logo {
    display:          flex;
    flex-direction:   row;
    text-decoration:  none;


    // Temporary, logo contains clear margins:
    margin-left: -9px;

    img {
      height: 40px;
    }

    .text {
      font-family:    Poppins;
      font-size:      32px;
      line-height:    40px;
      color:        #0099ee;
      letter-spacing: 3px;
    }
  }

  .controls {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}
</style>
